export default __webpack_public_path__ + "static/media/interoperability_and_portability.f612fd8a.png";